import styled from 'styled-components';

const StyledMedicalConsentAndAuthorizationPrintModalMessage = styled.div`
   padding-bottom: 24px;
`;

StyledMedicalConsentAndAuthorizationPrintModalMessage.displayName =
   'StyledMedicalConsentAndAuthorizationPrintModalMessage';

export { StyledMedicalConsentAndAuthorizationPrintModalMessage };
